<template>
  <div class="massive-h5">
    <div>
      <div class="warp" v-if="fileObj">
        <img src="./topLogo.png" alt="" />
        <div class="title">课内海量阅读</div>
        <!-- <input type="text" v-model="link" placeholder="请输入分享链接" /> -->
        <input
          type="text"
          v-if="isCode == 1"
          v-model="code"
          placeholder="请输入提取码"
        />
        <button @click="btn">下载文件</button>
        <div class="detail fixed">
          <span v-if="fileObj.expireTime"
            >资源{{ fileObj.expireTime }}前有效</span
          >
          <span v-if="fileObj.canDownloadCount > 0"
            >剩余可下载{{ fileObj.canDownloadCount }}次</span
          >
        </div>
      </div>
      <div class="warp" v-if="!fileObj">
        <img src="./topLogo.png" alt="" />
        <div class="detail">分享的文件链接已经失效了，下次要早点哟</div>
      </div>
    </div>
    <div class="bg" v-if="progress != 0 && progress != 100">
      <el-progress
        class="progress"
        type="circle"
        :percentage="progress"
      ></el-progress>
      <div class="totalSize">
        <div class="fileName">文件名称：{{ fileObj.fileName }}</div>
        <div>文件大小：{{ totalSize }}M</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "HelloWorld",
  data() {
    return {
      link: "",
      code: "",
      isCode: 1,
      totalSize: 0,
      fileObj: {
        canDownloadCount: 0,
        expireTime: "",
        fileName: "",
        fileSize: "",
        url: "",
      },
      progress: 0,
    };
  },
  created() {
    this.geturlparam();
  },
  methods: {
    geturlparam() {
      let that = this;
      // window.location.href 获取地址
      let url = window.location.href;
      let p = url.split("?")[1];
      let params = new URLSearchParams(p);
      console.log(params.get("link")); //1
      console.log(params.get("isCode")); //2
      this.link = params.get("link");
      this.isCode = params.get("isCode");
    },
    /**
     * 获取 blob
     * @param  {String} url 目标文件地址
     * @return {cb}
     */
    getBlob(url, cb) {
      let t = this;
      var xhr = new XMLHttpRequest();

      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.onprogress = (res) => {
        console.log(res);
        if (res.loaded) {
          t.progress = parseInt((res.loaded / res.total) * 10000) / 100;
          t.totalSize = (res.total / 1024 / 1024).toFixed(2);
        }
        // const timeStr = dayjs(new Date()).unix();
        // this.$set(this.fileProgress, file.name + timeStr, 0);
      };
      xhr.send();
    },
    /**
     * 保存
     * @param  {Blob} blob
     * @param  {String} filename 想要保存的文件名称
     */
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },
    btn() {
      let t = this;
      this.$axios
        .get(
          // "http://192.168.1.76:9555/admin/sys-file/share/download?link=" +
          "http://h5.knhlyd.com/api/admin/sys-file/share/download?link=" +
            this.link +
            "&code=" +
            this.code,
          {
            headsers: {
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data.code == 0) {
            t.fileObj = response.data.data;
            t.getBlob(response.data.data.url, (blob) => {
              t.saveAs(blob, response.data.data.fileName);
            });
          } else {
            console.log(1);
            this.$message.warning(response.data.msg);
          }
        })
        .catch((response) => {
          console.log("get发送Ajax请求,请求失败", response);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
}
.bg .totalSize {
  color: #fff;
  position: fixed;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.totalSize .fileName {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin-bottom: 20px;
}
.massive-h5 {
  width: 100%;
  height: 100%;
  background: #e6eef4;
  overflow: hidden;
}
.warp {
  width: 300px;
  margin: 0 auto;
}

img {
  width: 160px !important;
  height: 160px;
  display: block;
  margin-top: 100px !important;
}

.warp > * {
  margin: 30px auto;
  display: block;
  width: 300px;
  text-align: center;
}

input {
  height: 56px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #d9d9d9;
}

.title {
  height: 42px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #568abf;
  line-height: 42px;
  letter-spacing: 3px;
}

button {
  height: 56px;
  border: 1px solid #568abf;
  background: #568abf;
  border-radius: 16px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
}

.detail {
  height: 24px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #568abf;
  line-height: 24px;
}

.fixed {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue